import styled from '@emotion/styled'
import React from 'react'

import FeatureToggle, { Props as FeatureToggleProps } from './FeatureToggle'
import { FeatureItem, FeaturesList } from './FeaturesList'

type Props = FeatureToggleProps & {
	title: string
	dataTestId?: string
	features: { icon: React.ReactNode; label: string }[]
}

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	background-color: ${({ theme }) => theme.colors.light.secondaryBackgroundColor};
	padding: ${({ theme }) => theme.spaces.space6};
	border: 1px solid ${({ theme }) => theme.colors.light.borderColor};
	border-radius: ${({ theme }) => theme.borderRadiuses.lg};
`

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const Title = styled.p`
	${({ theme }) => theme.typography.paragraphMedium};
	color: ${({ theme }) => theme.colors.light.primaryTextColor};
	margin: 0;
`

const FeatureCard = ({ title, features, dataTestId, ...toggleProps }: Props) => (
	<Card data-testid={dataTestId}>
		<Header>
			<Title>{title}</Title>
			<FeatureToggle compact {...toggleProps} />
		</Header>
		<FeaturesList>
			{features.map(({ icon, label }, index) => (
				<FeatureItem key={index}>
					{icon}
					<span>{label}</span>
				</FeatureItem>
			))}
		</FeaturesList>
	</Card>
)

export default FeatureCard
